<template>
  <section
    id="f3vCjFysfaYgBxnsDcfOh+0/+Jgv9HhEdkVzwJHNrvo="
    class="profil_area pt-100 pb-100"
  >
    <div class="container mt-40">
      <!-- START HEADER -->
      <div class="row justify-content-left">
        <div class="col-lg-6">
          <div class="section_title text-left pb-55">
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              <span style="border-top: 5px solid black"> Profil </span>
            </h4>
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              TJSL KAI
            </h4>
            <span
              class="wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s"
            >
              <p style="color: black">Profil</p>
            </span>
          </div>
        </div>
      </div>
      <!-- END HEADER -->

      <!-- START CONTENT -->
      <div
        class="sub-menu-bar wow fadeInUp"
        data-wow-duration="1.3s"
        data-wow-delay="0.2s"
      >
        <ul id="prof" class="tab-profil">
          <li class="profil-item" v-for="(profil, index) in profils" :key="index">
            <a
              :class="{ active: profil.type === active_profil_class}"
              @click="showProfilDesc(profil)">{{ profil.tipe }}
            </a>
          </li>
        </ul>
        <div class="mt-50">
          <p>
            <span v-html="currentDesc"></span>
          </p>
        </div>
      </div>
      <!-- END CONTENT -->
    </div>
  </section>
</template>
<script>
import ProfilDataService from "../services/ProfilDataService";
export default {
  name: "profilView",
  components: {},
  data() {
    return {
      profils: [],
      currentIndex: -1,
      currentDesc: "",
      active_profil_class:"",
      title: "",
      lastIndex: 0,
      index: 0,
    };
  },
  methods: {
    activated() { },
    retrieveProfils() {
      ProfilDataService.getAll(4)
        .then((response) => {
          this.profils = response.data.data;
          this.currentIndex = 0;
          this.currentDesc = this.profils[0].deskripsi;
          this.active_profil_class = this.profils[0].type;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    showProfilDesc(profil){
      this.currentDesc = profil.deskripsi;
      this.active_profil_class = profil.type;
      //console.log(profil);
    }

  },
  mounted() {
    this.retrieveProfils();
  },
};
</script>

<style>
.tab-profil {
  display: flex;
  flex-direction: row;
  padding-left: 0;
  margin-bottom: auto;
}
.profil-item {
  position: relative;
  margin-right: 40px;
}

.tab-profil .profil-item a {
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 400;
  color: black;
  padding: 10px 0;
  position: relative;
}
.tab-profil .profil-item a:hover {
        color: #F06A25;
        cursor: pointer;
}

.tab-profil .profil-item a.active {
        color: #F06A25;
}

.tab-profil .profil-item a.active::before, .tab-profil .profil-item a:hover:before {
  width: 100%;
  color: #F06A25;
}

.tab-profil .profil-item a::before {
    position: absolute;
    content: '';
    bottom: 0;
    left: 0;
    width: 0;
    height: 3px;
    background-color: #F06A25;
    -webkit-transition: all .3s ease-out 0s;
    -moz-transition: all .3s ease-out 0s;
    -ms-transition: all .3s ease-out 0s;
    -o-transition: all .3s ease-out 0s;
    transition: all .3s ease-out 0s
}


</style>
